import { ImageSlides } from './components/ImageSlides';
import { DescriptionSlides } from './components/DescriptionSlides';
import { h, Fragment } from "preact";

export type SlidesProps = {
  slides: any;
  activeSlideId: number;
}

function Slides({ slides, activeSlideId }: SlidesProps) {
  // console.log("Slides prop from <Slides />", slides);
  return (
    <div id="index-slider" className="index__wrapper-slider-slide">
      <DescriptionSlides 
        slides={slides}
        activeSlideId={activeSlideId}
      />

      <ImageSlides 
        slides={slides}
        activeSlideId={activeSlideId}
      />
    </div>
  )
}

export { Slides };
